import { useState, useCallback } from "react";
import type { PoolMembership } from "../types/pools";

type WizardMode = "create" | "edit";

export function useWizard(onClose?: () => void) {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState<WizardMode>("create");
  const [pool, setPool] = useState<PoolMembership | null>(null);

  const open = useCallback((wizardMode: WizardMode, poolData?: PoolMembership) => {
    setMode(wizardMode);
    setPool(poolData ?? null);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    onClose?.();
  }, [onClose]);

  return {
    isOpen,
    mode,
    pool,
    open,
    close,
  };
}
